// =========================================================
// * Vue Material Dashboard Laravel PRO - v1.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-laravel-pro
// * Copyright Creative Tim (https://www.creative-tim.com) & UPDIVISION (https://www.updivision.com)
//
// * Coded by www.creative-tim.com & www.updivision.com
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue';
import axios from 'axios';

// Plugins

// Critical first:
import errorHandler from './store/modules/error-handler-module';
Vue.use(errorHandler);

import App from './App.vue';
import Chartist from 'chartist';
import VueAxios from 'vue-axios';
import DashboardPlugin from './material-dashboard';
import VueMeta from 'vue-meta';
import IsDemo from './isDemo';
import VueScrollTo from 'vue-scrollto';
import Popover from 'vue-js-popover';
import Vuelidate from 'vuelidate';
import VueMoment from 'vue-moment';
import JsonCSV from 'vue-json-csv';
import vueDebounce from 'vue-debounce';
import vueCountryRegionSelect from 'vue-country-region-select';
import VueClickOutsideComponent from 'vue-click-outside-component';
import { StripePlugin } from '@vue-stripe/vue-stripe';
import browserDetect from 'vue-browser-detect-plugin';

const stripeOptions = {
  pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
  stripeAccount: process.env.VUE_APP_STRIPE_ACCOUNT,
  apiVersion: process.env.VUE_APP_STRIPE_API_VERSION,
  locale: process.env.VUE_APP_STRIPE_LOCALE,
};

Vue.use(StripePlugin, stripeOptions);
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
// Vue.use(IsDemo);
Vue.use(VueMeta, { keyName: 'head' });
Vue.use(VueScrollTo);
Vue.use(Popover);
Vue.use(Vuelidate);
Vue.use(VueMoment);
Vue.use(vueDebounce);
Vue.use(vueCountryRegionSelect);
Vue.use(VueClickOutsideComponent);
Vue.use(browserDetect);

// router & store setup
import router from './router';
import store from './store';

// global library setup
Vue.prototype.$Chartist = Chartist;

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

/* eslint-disable no-new */
const app = new Vue({
  router: router,
  store: store,
  el: '#app',
  render: (h) => h(App),
});

store.$app = app;
